export default class DOMHelper {
	static getDocumentHeight() {
		return Math.max(
			document.body.scrollHeight, document.documentElement.scrollHeight,
			document.body.offsetHeight, document.documentElement.offsetHeight,
			document.body.clientHeight, document.documentElement.clientHeight
		);
	}

	static copyTextToClipboard(text) {
		/* Fallback if navigator.clipboard is not available */
		if (!navigator.clipboard) {
			var textArea = document.createElement("textarea");
			textArea.value = text;

			// Avoid scrolling to bottom
			textArea.style.top = "0";
			textArea.style.left = "0";
			textArea.style.position = "fixed";

			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			try {
				var successful = document.execCommand('copy');
				var msg = successful ? 'successful' : 'unsuccessful';
				console.log('Fallback: Copying text command was ' + msg);
			} catch (err) {
				console.error('Fallback: Oops, unable to copy', err);
			}

			document.body.removeChild(textArea);
			return;
		}

		/* Copy to clipboard */
		navigator.clipboard.writeText(text).then(function() {
			console.log('Async: Copying to clipboard was successful!');
		}, function(err) {
			console.error('Async: Could not copy text: ', err);
		});
	}

	static createElement(tagName, options = {}) {
		const attributes = options.attributes || {};
		const text = options.text || null;
		const html = options.html || null;
		const children = options.children || [];
		const subscriptions = options.subscriptions || [];
		const $parent = options.$parent || null;

		/* Exceptions */
		if (tagName == null) {
			throw new Error('DOMHelper / Create element: Tag name is not defined.');
		}

		if (text !== null && (children.length || html !== null)) {
			throw new Error('DOMHelper / Create element: You should use only text/html content or add children elements.');
		}

		/* Create Element */
		const element = document.createElement(tagName);

		/* Add attributes */
		const attrKeys = Object.keys(attributes);

		if (attrKeys.length) {
			attrKeys.forEach((key) => {
				let value = attributes[key];

				if (key === 'class' && Array.isArray(value)) {
					value = value.join(' ');
				}

				element.setAttribute(key, value);
			});
		}

		/* Add text content */
		if (text !== null) {
			element.textContent = text;
		}

		/* Add html content */
		if (html !== null) {
			element.innerHTML = html;
		}

		/* Add children */
		if (children !== null) {
			children.forEach((child) => {
				element.appendChild(child);
			});
		}

		/* Add subscriptions */
		if (subscriptions.length) {
			subscriptions.forEach((subscription) => {
				if (typeof subscription !== 'object') {
					throw new TypeError('DOMHelper / Create element: Subscriptions elements must be objects.');
				}

				if (!subscription.hasOwnProperty('event') || !subscription.hasOwnProperty('listener')) {
					throw new Error('DOMHelper / Create element: There must be \'event\' and \'listener\' for subscription.');
				}

				element.addEventListener(subscription.event, subscription.listener);
			});
		}

		if ($parent) {
			$parent.append(element);
		}

		return element;
	}

	/* HTML Templates */
	static getChipInputTemplate({ name, label, value }) {
		return (`
			<label class="chip">
				<input type="radio" class="chip_input" name="${name}" value="${value}">
				<span class="chip_checkmark">${label}</span>
			</label>
		`);
	}

	static hide($el) {
		$el.style.display = 'none';
	}

	static show($el, display = 'block') {
		$el.style.display = display;
	}

	static addClass($el, className) {
		$el.classList.add(className);
	}

	static removeClass($el, className) {
		$el.classList.remove(className);
	}

	static tooltips() {
		if (window.matchMedia('(max-width: 768px)').matches) return;

		const $tooltips = document.querySelectorAll('.with-tooltip_text');

		if ($tooltips.length) {
			$tooltips.forEach(($element) => {
				$element.style.left = `calc(50% - ${$element.offsetWidth / 2}px)`;
			});
		}
	}

	static getElementTopPosition($elem) {
		return Math.floor($elem.getBoundingClientRect().top + pageYOffset);
	}

	static loadYouTubePlayer(onLoad) {
		if (document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
			return;
		}

		const firstScriptTag = document.getElementsByTagName('script')[0];
		const tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		tag.onload = () => {
			if (typeof onLoad === 'function') {
				onLoad();
			}
		};
	}
}